import { TABLE_AXIS_MENU_MIN_WIDTH_PX } from "./constants";
import type { TableAxisMenuAnchor } from "./types";

export function snapTableAxisMenuAnchor(r: DOMRect): TableAxisMenuAnchor {
  return {
    top: r.top,
    left: r.left,
    bottom: r.bottom,
    right: r.right,
    width: r.width,
    height: r.height,
  };
}

export function clampAxisMenuLeft(left: number): number {
  if (typeof window === "undefined") return left;
  const pad = 8;
  return Math.max(pad, Math.min(left, window.innerWidth - TABLE_AXIS_MENU_MIN_WIDTH_PX - pad));
}

export function clampAxisMenuTop(top: number, estimatedMenuHeight: number): number {
  if (typeof window === "undefined") return top;
  const pad = 8;
  return Math.max(pad, Math.min(top, window.innerHeight - estimatedMenuHeight - pad));
}
